import { render, staticRenderFns } from "./settingGLAccounts2.vue?vue&type=template&id=19d0dca4&scoped=true&"
import script from "./settingGLAccounts2.vue?vue&type=script&lang=js&"
export * from "./settingGLAccounts2.vue?vue&type=script&lang=js&"
import style0 from "./settingGLAccounts2.vue?vue&type=style&index=0&id=19d0dca4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d0dca4",
  null
  
)

export default component.exports